import { Component, OnInit } from "@angular/core";
import { UserMgmtService } from "../user.service";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-user-recent-bookings",
  templateUrl: "./user-recent-bookings.component.html",
  styleUrls: ["./user-recent-bookings.component.scss"],
})
export class UserRecentBookingsComponent implements OnInit {
  userList = [];
  total: number = 0;
  pageLimit: number = 10;
  currentPage: number = 0;
  totalPage: number;
  isLoading: boolean = false;
  searchStartDate: any;
  searchEndDate: any;
  minDate: any;
  maxDate: any;
  modalRef: NgbModalRef;
  modalOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };
  selectedUserBookingData: any;
  closeResult: string;

  constructor(
    private userMgmtService: UserMgmtService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.setDefaultDates();
    this.getUserList();
  }

  setDefaultDates() {
    const now = new Date();
    const startOfYear = new Date(now.getFullYear(), 0, 1);
    this.searchStartDate = startOfYear;
    this.searchEndDate = now;
    this.minDate = startOfYear;
    this.maxDate = now;
  }

  formatDate(date: any): string {
    if (!date) return "";
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  getUserList() {
    this.isLoading = true;
    const offset = this.currentPage * this.pageLimit;
    
    let query = `offset=${offset}&limit=${this.pageLimit}&expand=addresses&expand=lastBooking&lastBookedExclude=true&expand=bookingData`;
    
    if (this.searchStartDate) {
      query += `&lastBookedFrom=${this.formatDate(this.searchStartDate)}`;
    }
    if (this.searchEndDate) {
      query += `&lastBookedTo=${this.formatDate(this.searchEndDate)}`;
    }

    this.userMgmtService.getUserListApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["statusCode"] === 200) {
          this.userList = res["data"]["userList"];
          this.total = res["data"]["totalCount"];
          this.setPagination();
        } else {
          this.userList = [];
          this.total = 0;
        }
      },
      (err) => {
        this.isLoading = false;
        this.userList = [];
        this.total = 0;
      }
    );
  }

  setPagination() {
    this.totalPage = Math.ceil(this.total / this.pageLimit);
    if (this.totalPage === 0) this.totalPage = 1;
  }

  nextPage() {
    if (this.currentPage + 1 < this.totalPage) {
      this.currentPage++;
      this.getUserList();
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.getUserList();
    }
  }

  changePageLimit() {
    this.currentPage = 0;
    this.getUserList();
  }

  searchFiltersBtn() {
    this.currentPage = 0;
    this.getUserList();
  }

  onReset() {
    this.setDefaultDates();
    this.currentPage = 0;
    this.getUserList();
  }


changeEndDate() {
  this.maxDate = this.searchEndDate;
}
  getFrequency(bookingData: any): string {
    if (!bookingData || !bookingData.howOftens) {
      return "--";
    }
    const howOftens = bookingData.howOftens;
    const keys = Object.keys(howOftens);
    if (keys.length === 0) {
      return "--";
    }
    return keys.map((key) => `${key} (${howOftens[key]})`).join(", ");
  }

  openFrequencyModal(row, content) {
    this.selectedUserBookingData = row.bookingData;
    this.modalOptions = {
        backdrop: "static",
        keyboard: false,
        size: "md",
        centered: true,
      };
  
      this.modalRef = this.modalService.open(content, this.modalOptions);
      this.modalRef.result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }



  changeStartDate() {
    this.minDate = this.searchStartDate;
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}
